module.exports = __webpack_public_path__ + "ad52a414286b292c1fa1a2ae18756d0a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/reading/open-book.png
// module id = 3599
// module chunks = 0